import AnalyticsEmailCampaignChart from 'components/charts/e-charts/AnalyticsEmailCampaignChart';

const EmailCampaign = () => {
  return (
    <div className="scrollbar">
      <h3>Neuroskill Date Report</h3>
      <p className="text-body-tertiary">
        Based on daily usage
      </p>
      <AnalyticsEmailCampaignChart className="echart-contacts-width" />
    </div>
  );
};

export default EmailCampaign;
